import * as Yup from 'yup';

export const initialValues = {
    agenda: '',
    description: '',
    // resource: '',
    role: 'student',
};

export const validationSchema = Yup.object({
    agenda: Yup.string().required('Agenda is required'),
    description: Yup.string()
        .required('Description is required')
        .min(50, 'Minimum 50 characters are required')
        .max(500, 'Maximum 500 characters are required'),
    // resource: Yup.string().required('resource is required'),
    role: Yup.string().required('Role is required'),
});
